import React from 'react';
import { cx } from '../cx';

// D-09 §15.34 — Status Hint (.status-hint · status-hint-<tone> · 아이콘 + 텍스트, 배경 없음)
// 아이콘에만 status 색(attention=error 재사용, D-08 §6.5), 텍스트는 중립(shell.onSurface2).
export interface StatusHintProps extends React.HTMLAttributes<HTMLSpanElement> {
  icon?: React.ReactNode;
  tone?: 'info' | 'attention' | 'success' | 'warning' | 'error' | 'muted';
}

export function StatusHint({ icon, tone = 'muted', className = '', children, ...props }: StatusHintProps) {
  return (
    <span className={cx('status-hint', `status-hint-${tone}`, className)} {...props}>
      {icon != null && <span className="status-hint-ic" aria-hidden="true">{icon}</span>}
      <span className="status-hint-tx">{children}</span>
    </span>
  );
}
